// extracted by mini-css-extract-plugin
module.exports = {"TreatwellSansWeb-Light":"fonts-module--TreatwellSansWeb-Light--ff7672"};